import { render } from "./ResellersForm.vue?vue&type=template&id=4b52fd35"
import script from "./ResellersForm.vue?vue&type=script&lang=js"
export * from "./ResellersForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__